// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CalendarioController from "./calendario_controller"
application.register("calendario", CalendarioController)

import CheckAllController from "./check_all_controller"
application.register("check-all", CheckAllController)

import Itens__FinalizacaoController from "./itens/finalizacao_controller"
application.register("itens--finalizacao", Itens__FinalizacaoController)

import Participantes__CargoController from "./participantes/cargo_controller"
application.register("participantes--cargo", Participantes__CargoController)

import Participantes__SortController from "./participantes/sort_controller"
application.register("participantes--sort", Participantes__SortController)

import PhoneMaskController from "./phone_mask_controller"
application.register("phone-mask", PhoneMaskController)

import Publico__RefreshController from "./publico/refresh_controller"
application.register("publico--refresh", Publico__RefreshController)

import Sessoes__FormController from "./sessoes/form_controller"
application.register("sessoes--form", Sessoes__FormController)

import ShowMoreController from "./show_more_controller"
application.register("show-more", ShowMoreController)

import TogglerController from "./toggler_controller"
application.register("toggler", TogglerController)

import Ui__CascadeController from "./ui/cascade_controller"
application.register("ui--cascade", Ui__CascadeController)

import Ui__ComboboxController from "./ui/combobox_controller"
application.register("ui--combobox", Ui__ComboboxController)

import Ui__DisclosureController from "./ui/disclosure_controller"
application.register("ui--disclosure", Ui__DisclosureController)

import Ui__DismissController from "./ui/dismiss_controller"
application.register("ui--dismiss", Ui__DismissController)

import Ui__DropdownController from "./ui/dropdown_controller"
application.register("ui--dropdown", Ui__DropdownController)

import Ui__FileFieldController from "./ui/file_field_controller"
application.register("ui--file-field", Ui__FileFieldController)

import Ui__ModalController from "./ui/modal_controller"
application.register("ui--modal", Ui__ModalController)

import Ui__RemoteToggleController from "./ui/remote_toggle_controller"
application.register("ui--remote-toggle", Ui__RemoteToggleController)

import Ui__TabsController from "./ui/tabs_controller"
application.register("ui--tabs", Ui__TabsController)

import Ui__TabsNavController from "./ui/tabs_nav_controller"
application.register("ui--tabs-nav", Ui__TabsNavController)

import Ui__TooltipController from "./ui/tooltip_controller"
application.register("ui--tooltip", Ui__TooltipController)

import Ui__TurboModalController from "./ui/turbo_modal_controller"
application.register("ui--turbo-modal", Ui__TurboModalController)

import Ui__UploadFormController from "./ui/upload_form_controller"
application.register("ui--upload-form", Ui__UploadFormController)
